import { ServerType } from '../servers/server-type.model';
import { ServerState } from '../servers/server-state.model';

export class Server {
	serverId: string;
	id: string;
	instanceId: string;
	serverIP: string;
	lastPing: Date;
	serverType: ServerType;
	serverState: ServerState;
	serverStateTimestamp: Date;
	isAvailableForProcessing: boolean;
	isStop: boolean;
	serverStateDiff: string;
	lastPingDiff: string;
	availableMemoryInMB: number;
	assemblyVersion: string;

	constructor(server: ServerParams) {
		this.serverId = server.serverId;
		this.id = server.serverId;
		this.instanceId = server.instanceId;
		this.serverIP = server.serverIP;
		this.lastPing = server.lastPing;
		this.serverType = server.serverType;
		this.serverState = server.serverState;
		this.serverStateTimestamp = server.serverStateTimestamp;
		this.isAvailableForProcessing = server.isAvailableForProcessing;
		this.assemblyVersion = server.assemblyVersion;
		this.availableMemoryInMB = server.availableMemoryInMB;
		this.isStop = server.isStop;
		this.serverStateDiff = this.computeDateDiff(this.serverStateTimestamp);
		this.lastPingDiff = this.computeDateDiff(this.lastPing);
	}

	private computeDateDiff(inDate: Date): string {
		const now = new Date();
		const nowOffset = now.getTimezoneOffset();
		const nowMs = now.getTime();
		const dateMs = new Date(inDate).getTime();

		let dateDiff = nowMs - dateMs;
		dateDiff += (nowOffset * 60 * 1000);

		let seconds = Math.abs(dateDiff) / 1000;
		const hours = Math.floor(seconds / 3600);
		seconds -= hours * 3600;
		const minutes = Math.floor(seconds / 60) % 60;
		seconds -= minutes * 60;
		seconds = Math.floor(seconds);

		return `${ String(hours).padStart(2, '0') }:${ String(minutes).padStart(2, '0') }:${ String(seconds).padStart(2, '0') }`;
	}
}

interface ServerParams {
	serverId: string;
	instanceId: string;
	serverIP: string;
	lastPing: Date;
	serverType: ServerType;
	serverState: ServerState;
	serverStateTimestamp: Date;
	isAvailableForProcessing: boolean;
	isStop: boolean;
	serverStateDiff: string;
	lastPingDiff: string;
	availableMemoryInMB: number;
	assemblyVersion: string;
}
